import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import Quill from "quill";
import "quill/dist/quill.snow.css";

export default function useInformation(props) {
  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr();

  const vm = getCurrentInstance().proxy;

  const activeHover = {
    QUIZ_NAME: 1,
    QUIZ_DESC: 2,
  };

  const activeQuizName = ref(true);
  const activeQuizDesc = ref(false);

  const toggleActive = (type) => {
    switch (type) {
      case activeHover.QUIZ_NAME:
        activeQuizName.value = true;
        activeQuizDesc.value = false;
        break;
      case activeHover.QUIZ_DESC:
        activeQuizName.value = false;
        activeQuizDesc.value = true;
        break;
      default:
        activeQuizName.value = false;
        activeQuizDesc.value = false;
    }
    vm.$emit("set-active");
  };

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: {
        container: "#my-toolbar",
      },
      // "color-picker": true,
      // "emoji-toolbar": true,
      // "emoji-textarea": true,
      // "emoji-shortname": true,
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: /•\\s\\d\\.\\s[A-z]/,
          },
        },
      },
    },
  };

  const editorName = computed(() => vm.$refs.quizNameQuill.quill);
  const editorDesc = computed(() => vm.$refs.quizDescQuill.quill);

  const onFocusInput = (editor) => {
    editorName.value.focus();
    if (editor == "quizNameQuill") {
      editorName.value.focus();
    } else if (editor == "quizDescQuill") {
      editorDesc.value.focus();
    }
  };

  const onUploadBanner = (image) => {
    vm.$emit("onUploadBanner", image);
  };

  const onUploadDisplay = (image) => {
    vm.$emit("onUploadDisplay", image);
  };

  const nameNoHtml = computed(() =>
    props.formData.surveyName.replace(/<[^>]*>/g, "")
  );

  const descNoHtml = computed(() =>
    props.formData.surveyDesc
      ? props.formData.surveyDesc.replace(/<[^>]*>/g, "")
      : ""
  );

  onBeforeMount(() => {
    if (!props.formData.isEdit) {
      activeQuizName.value = false;
    }
  });

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,

    toggleActive,
    activeHover,
    customQuillOption,
    onFocusInput,
    activeQuizName,
    activeQuizDesc,
    onUploadBanner,
    onUploadDisplay,
    nameNoHtml,
    descNoHtml,
  };
}
